import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.updateOptions()
  }

  updateOptions() {
    const selectedFields = new Set(
      this.selectTargets
        .map((select) => select.value)
        .filter((value) => value && value !== "unused")
    )

    this.selectTargets.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        option.hidden = selectedFields.has(option.value) && option.value !== select.value
      })
    })
  }
}
